/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import {
  Dropdown,
  Feed,
  Icon,
  Placeholder,
  Popup,
  Dimmer,
  Header,
  Button,
} from 'semantic-ui-react';
import mMarked from '../../utils/marked';
import { BookingNotePropTypes } from '../../types';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { formatNoteTimestamp, formatNoteTooltip } from './noteTimestamp';

moment.locale('en-gb');

export const ListItemPlaceholder = () => (
  <Feed.Event key={0} className="bnl-item">
    <Feed.Label>
      <Placeholder>
        <Placeholder.Image square />
      </Placeholder>
    </Feed.Label>
    <Feed.Content>
      <Feed.Extra>
        <Placeholder>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
          <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder.Paragraph>
        </Placeholder>
      </Feed.Extra>
    </Feed.Content>
  </Feed.Event>
);

export const ListItemEmpty = ({ t }) => (
  <Feed.Event className="bnl-empty-item">
    <Feed.Content>
      <p>{t('No notes found')}</p>
    </Feed.Content>
  </Feed.Event>
);

ListItemEmpty.propTypes = {
  t: PropTypes.func,
};

const ListItem = ({ bookingNote, canManage, countryCode, hasAccess, isLastIndex, listIndex, noteIsDeleting, noteIsDisabled, noteIsEditing, onDelete, onEdit, i18n, t }) => {
  const numberToColor = (number) => {
    if (typeof number === 'number' && Number.isInteger(number)) {
      const colors = ['#B03060', '#FE9A76', '#FFD700', '#32CD32', '#016936', '#EE82EE', '#B413EC', '#FF1493', '#A52A2A', '#A0A0A0'];
      const colorIndex = (number - 1) % colors.length;
      return colors[colorIndex];
    }
    return '#0E6EB8';
  };
  const formatTimestamp = timestamp => formatNoteTimestamp(timestamp, countryCode, {
    language: i18n.language,
    atLabel: t('at'),
    yesterdayAtLabel: t('Yesterday at'),
  });
  const privacyIcon = (privacy) => {
    switch (privacy) {
      case 'public':
        return 'globe';
      case 'internal':
        return 'users';
      case 'private':
        return 'lock';
      default:
        return 'globe';
    }
  };
  const privacyTitle = (privacy) => {
    switch (privacy) {
      case 'public':
        return 'Public';
      case 'internal':
        return 'Internal';
      case 'private':
        return 'Only Me';
      default:
        return 'Public';
    }
  };
  const isSystemUser = (name) => {
    if (name.toLowerCase().includes('system')) return true;
    return false;
  };
  const getNote = (bNote) => {
    try {
      const hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };
  return (
    <Dimmer.Dimmable
      as={Feed.Event}
      className={`bnl-item ${noteIsEditing ? 'is-editing' : ''} ${noteIsDisabled ? 'is-disabled' : ''}`}
      dimmed={noteIsDeleting}
      id={`fe_${listIndex}`}
      key={listIndex}
    >
      <Feed.Label>
        <span className="bnl-item-avatar" style={{ backgroundColor: numberToColor(bookingNote.muID) }}>
          {bookingNote.muName ? bookingNote.muName.charAt(0).toUpperCase() : <div><Icon inverted fitted color="teal" name="user" /></div>}
        </span>
      </Feed.Label>
      <Feed.Content>
        <Feed.Summary>
          <div className="bnl-item-title-info">
            {
              (hasAccess && !isSystemUser(bookingNote.muPreferredName)) ? <Feed.User as={Link} to={`/users/${bookingNote.muAffiliateID}/`}>{bookingNote.muPreferredName} <small>({bookingNote.muName})</small></Feed.User>
              : <Feed.User>{bookingNote.muPreferredName} <small>({bookingNote.muName})</small></Feed.User>
            }
            <Feed.Extra className="bnl-item-date-privacy">
              <Feed.Date>
                <Popup
                  trigger={<span className="timedate">{formatTimestamp(bookingNote.createdAt)}</span>}
                  content={formatNoteTooltip(bookingNote.createdAt, countryCode, t('at'))}
                  position={isLastIndex ? 'top left' : 'bottom left'}
                  flowing
                  inverted
                  size="mini"
                />
                {(bookingNote.createdAt !== bookingNote.updatedAt) ?
                  <Popup
                    trigger={<span> <span className="timedate">({t('edited')})</span></span>}
                    content={formatNoteTooltip(bookingNote.updatedAt, countryCode, 'at')}
                    position={isLastIndex ? 'top left' : 'bottom left'}
                    flowing
                    inverted
                    size="mini"
                  />
                  : ''}
                &nbsp;·&nbsp;
                <Popup
                  trigger={<span><Icon name={privacyIcon(bookingNote.privacy)} /></span>}
                  content={t(privacyTitle(bookingNote.privacy), { ns: TRANSLATION_FILES.constants })}
                  position={isLastIndex ? 'top left' : 'bottom left'}
                  flowing
                  inverted
                  size="mini"
                />
              </Feed.Date>
            </Feed.Extra>
          </div>
          <div className="bnl-item-edit-menu">
            {
              canManage ? (
                <Dropdown
                  icon={null}
                  pointing={isLastIndex ? 'bottom right' : 'top right'}
                  selectOnBlur={false}
                  trigger={<Icon color="grey" name="ellipsis vertical" />}
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      icon="pencil"
                      text={t('Edit', { ns: TRANSLATION_FILES.translation })}
                      onClick={() => onEdit(bookingNote)}
                    />
                    <Dropdown.Item
                      icon="trash"
                      text={t('Delete', { ns: TRANSLATION_FILES.translation })}
                      onClick={() => onDelete(bookingNote.id, 'open')}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              ) : ''
            }
          </div>
        </Feed.Summary>
        <Feed.Extra className="bnl-item-note-content">
          <div className="bnl-item-markdown m-marked" dangerouslySetInnerHTML={{ __html: mMarked.parse(getNote(bookingNote.note)) }} />
        </Feed.Extra>
        <Dimmer
          active={noteIsDeleting}
          inverted
          className="bnl-item-delete-dialog"
          verticalAlign="top"
        >
          <Header size="tiny" color="red">{t('Confirm Delete Note')}?</Header>
          <Button size="mini" onClick={() => onDelete(bookingNote.id, 'close')} compact color="teal"><Icon name="x" />{t('Cancel', { ns: TRANSLATION_FILES.translation })}</Button>
          <Button size="mini" onClick={() => onDelete(bookingNote.id, 'delete')} compact color="red"><Icon name="trash" />{t('Delete Note')}</Button>
        </Dimmer>
      </Feed.Content>
    </Dimmer.Dimmable>
  );
};

ListItem.propTypes = {
  bookingNote: BookingNotePropTypes,
  noteIsDeleting: PropTypes.bool,
  noteIsDisabled: PropTypes.bool,
  noteIsEditing: PropTypes.bool,
  canManage: PropTypes.bool,
  listIndex: PropTypes.number,
  isLastIndex: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  hasAccess: PropTypes.bool,
  countryCode: PropTypes.string,
  i18n: PropTypes.shape({
    language: PropTypes.string,
  }),
  t: PropTypes.func,
};


// Connected here rather than at the SharedNote/BookingNote callers so every list that renders a
// note item gets the viewer's zone, using the same reactive company selector as components/Timestamp.
const mapStateToProps = state => ({
  countryCode: state.auth && state.auth.company && state.auth.company.countryCode,
});

export default withTranslation(namespaces)(connect(mapStateToProps)(ListItem));



// WEBPACK FOOTER //
// ./src/components/BookingNote/ListItem.jsx